import {createSelector} from 'reselect';

export const getRouter = state => state.router;

export const getRoute = createSelector(getRouter, router => router.route);
